<!--  -->
<template>
  <div class="classification">
    <div style="height: 8px;"></div>
    <div class="form-inLine">
      <el-form ref="formTool" :inline="true" style="text-align: left">
            <el-form-item>
              <el-select v-model="goodsType" style="width: 126px">
                <el-option label="自营商品" value="自营商品" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select @change="(val) => {goodsBaseChange(val);}" v-model="goodsBaseName" style="width: 160px">
                <el-option v-for="(item, index) in goodsBaseTypeList" :key="index" :label="item.name" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select filterable @change="chooseProvince" v-model="provinceName" style="width: 160px">
                <el-option v-for="(item, index) in dfcTreeList" :key="index" :label="item.name" :value="item.name" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="query()" type="primary">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="reset()" type="info">重置</el-button>
            </el-form-item>
      </el-form>
      <div style="margin-left: auto;">
        <el-form :inline="true">
          <el-form-item label="学术康贝收业务款">
            <el-tooltip :width="300" effect="dark" placement="top-start" class="custom-tooltip-warp">
              <template slot="content">
                <div class="custom-tooltip">
                  使用资金自动分流并打开此处开关后，省区公司的订单资金自动给康贝号分流时，学术康贝可以收取业务款；关闭开关时，订单资金自动分流时不会流向学术康贝。（若省区公司的学术康贝和业务康贝是同一康贝号，则业务款和学术款都会流入该康贝、不受开关影响。）开关对特定客户分账规则一并生效
                </div>
              </template>
              <i class="el-icon-warning"></i>
            </el-tooltip>
            <el-switch v-model="studyBusinessFlag" :active-value="true" :inactive-value="false" active-color="#67c23a"
              inactive-color="#999" active-text="" @change="editDfStudyBusiness" />
              <el-button size="small" @click="submitProductPrice()" type="primary">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tag-box">
      <div class="tag-box-item">
        全局设置 销售定价
        <el-input v-model="tableTagForm.price" class="tag-input" size="small"
          onchange="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
        <div @click="openDaliog" class="unit-tag">
          <el-tag type="primary"> 元/{{ tableTagForm.goodsSkuUnit }}</el-tag>
        </div>
      </div>
      <div class="tag-box-item">
        合作医药公司
        <el-input v-model="tableTagForm.amount" class="tag-input" size="small"
          onchange="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
        元
      </div>
      <div class="tag-box-item">
        地区公司
        <el-input v-model="tableTagForm.city_amount" class="tag-input" size="small"
          onchange="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
        元
      </div>
      <div class="tag-box-item">
        地区公司转省区公司服务费
        <el-input v-model="tableTagForm.serviceAmount" class="tag-input" size="small"
          onchange="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
        元
      </div>

      <div class="tag-box-item">
        省区公司向学术资金专用账户转款
        <el-input v-model="tableTagForm.studyAmount" class="tag-input" size="small"
          onchange="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
        元
      </div>

      <div>
        <el-button size="small" @click="dataSynchronize()" type="primary">全局应用</el-button>
      </div>
      <div> 注：如没有地区公司，则分账金额划拨给省区公司 </div>
    </div>

    <div class="content-table">
      <selfPriceTable ref="self-price-table" :dfc-data="dfcTreeList" :unit-list="unitList" :goodsName="goodsBaseName"
        :goodsId="goodsBaseId" @addSuccess="query"></selfPriceTable>
    </div>

    <el-dialog title="选择单位" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
      <div class="content-box">
        <span :class="unitKey == key ? 'unit active' : 'unit'" v-for="(item, key) in unitList" :key="key"
          @click="choseUnit(item, key)">{{ item }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="choseUnitSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import selfPriceTable from "./components/selfPriceTable";
import {
  getUnit,
  goodsBaseType,
  getSelfPriceAndLedgerRule,
  getDfcTree,
} from "@/api/saleRule/productLine";
import { regionAreaTree } from "@/api/saleRule/saleF";
import { putDfStudyBusiness, getDfStudyBusiness } from "@/api/shopmange";
export default {
  components: { selfPriceTable },
  data() {
    return {
      goodsType: "自营商品",
      provinceName: "湖南",
      areaList: [],
      tableTagForm: {
        price: "",
        amount: "",
        city_amount: "",
        serviceAmount: "",
        goodsSkuUnit: "盒",
        studyAmount: null,
      },
      price: 0,
      unitList: [],
      studyBusinessFlag: false,
      page: {
        total: 0,
        current: 1,
        size: 20,
        pageSizes: [10, 20, 30, 50],
      },
      accountId: "",
      isAccount: false,
      dialogVisible: false,
      unitKey: 0,
      goodsBaseName: "",
      goodsBaseId: "",
      goodsBaseTypeList: [], //商品类型
      dfcTreeList: [], // 省地办组织list
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getUnit();
  },
  mounted() {
    this.getDfcTree(); // 获取省地办组织
    this.goodsBaseType();
  },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  methods: {
    // 查询学术康贝是否收业务款
    queryDfStudyBusiness() {
      let params = {
        orgCode: this.provinceOrgCode,
      };
      getDfStudyBusiness(params).then((res) => {
        // console.log(res,'--res')
        this.studyBusinessFlag = res;
      });
    },

    // 修改保存学术康贝是否收业务款
    editDfStudyBusiness(e) {
      let params = {
        orgCode: this.provinceOrgCode,
        studyBusinessFlag: e,
      };
      putDfStudyBusiness(params).then((res) => {
        // console.log(res,'--res')
        this.$message.success("修改成功！");
      });
    },

    chooseProvince(e) {
      this.provinceOrgCode = e;
    },
    // 切换商品下拉
    goodsBaseChange(val) {
      this.goodsBaseId = val.goodsId;
      this.goodsBaseName = val.name;
    },
    // 获取省地办组织树
    getDfcTree() {
      getDfcTree().then((res) => {
        this.dfcTreeList = res.data;
        this.dfcTreeList.map((item) => {
          if (item.name == this.provinceName) {
            this.provinceOrgCode = item.weight;
            this.queryDfStudyBusiness();
          }
        });
      });
    },
    // 查询单位集合
    getUnit() {
      let params = {};
      getUnit(params).then((res) => {
        if (res && res.code == 0) {
          this.unitList = res.data;
        }
      });
    },

    // 选择单位 弹窗
    openDaliog(row, rowIndex) {
      this.dialogVisible = true;
    },

    // 选择单位choseUnit
    choseUnit(e, key) {
      this.unitKey = key;
      this.tableTagForm.goodsSkuUnit = e;
    },

    // 获取自营商品列表 // 自营商品type固定传1
    goodsBaseType() {
      goodsBaseType(1).then((res) => {
        console.log(res, "res");
        if (res) {
          this.goodsBaseTypeList = res;
          this.goodsBaseId = res[0].goodsId;
          this.goodsBaseName = res[0].name;
          setTimeout(() => {
            this.query();
          }, 500);
        }
      });
    },

    // 确认选择单位
    choseUnitSure() {
      this.dialogVisible = false;
    },

    // 批量保存设置
    submitProductPrice(node) {
      this.$refs["self-price-table"].submit();
    },

    // 全局应用 顶部设置的价格数据
    dataSynchronize() {
      if (this.tableTagForm.price == "") {
        this.$message({
          message: "请输入销售定价",
          type: "warning",
        });
        return;
      }
      if (this.tableTagForm.amount == "") {
        this.$message({
          message: "请输入合作医药公司-销售金额",
          type: "warning",
        });
        return;
      }

      if (this.tableTagForm.serviceAmount == "") {
        this.$message({
          message: "请输入地区需转账省区服务费",
          type: "warning",
        });
        return;
      }

      this.$refs["self-price-table"].save(this.tableTagForm);
    },

    handleClose() {
      this.dialogVisible = false;
    },

    // 重置
    reset() {
      this.provinceName = "湖南";
      this.$refs["self-price-table"].init(this.provinceName);
      Object.keys(this.tableTagForm).forEach(
        (key) => (this.tableTagForm[key] = "")
      );
      this.tableTagForm.goodsSkuUnit = "盒";
      // this.tableTagForm.studyAmount = "60.00";
      this.getDfcTree();
    },
    query() {
      this.$refs["self-price-table"].init(this.provinceName);
      this.getDfcTree();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.classification {
  .form-inLine{
     display: flex;
     align-items: center;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 20px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);
  }

  .content-table {
    padding: 10px 20px;
  }

  .tag-input {
    width: 100px;
  }

  .tag-box {
    padding: 10px;
    background: rgba(255, 255, 0, 0.246);
    font-size: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    color: #666;
    .tag-box-item{
      display: flex;
      align-items: center;
      margin-right: 10px;
    }
  }

  .unit-tag {
    cursor: pointer;
  }

  .content-box {

    // display: flex;
    // flex-wrap: wrap;  
    // align-items: center;
    // background-color: cadetblue;
    .unit {
      padding: 5px;
      border: solid 1px #eee;
      color: #333;
      border-radius: 5px;
      margin: 0 5px;
      line-height: 40px;
    }

    .unit:hover {
      background: rgb(255, 73, 73);
      color: #fff;
      cursor: pointer;
    }

    .active {
      background: rgb(255, 73, 73);
      color: #fff;
    }
  }

  .unit-box {
    display: flex;
  }

  .unit-s {
    margin: 5px;
    cursor: pointer;
    color: #000;
  }

  .el-tooltip__popper {
    font-size: 14px;
    max-width: 20%
  }

  .custom-tooltip {
    width: 300px;
    /* 设置所需的宽度 */
  }

  .custom-tooltip-warp {
    // margin-top: 30px;
    position: relative;
    top: 2px;
    left: -10px;
    font-size: 18px;
    margin-right: 0px;
  }

  .business-flag {
    margin-right: 20px;
    display: flex;
    align-items: center;

  }
}
</style>
